import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import $ from 'jquery/dist/jquery';
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import './assets/fonts/fonts.css'
import store from './store'; 
import VueSmoothScroll from "vue2-smooth-scroll";

Vue.config.productionTip = false
Vue.prototype.$ = $
window.$ = $
window.jQuery = $

Vue.use(ElementUI)
Vue.use(VueSmoothScroll)
Vue.use(mavonEditor)

// 👇 👇 只加这一行！让 index.html 能拿到 vuex
window.$store = store

window.onerror = function(message, source, lineno, colno, error) {
  console.error('Global error caught:', message);
  return true;
};

document.addEventListener('contextmenu', (event) => {
  event.preventDefault()
  return false
})

new Vue({
  router,
  store, 
  render: h => h(App),
}).$mount('#app')